import { CustomButton, CustomLabel } from "@mindmemobile/mm-shared-global";
import styled from "styled-components";
import { PriceSelector } from "../components/PricingOption";
import {
  ItemIncreasePriceBy,
  ItemIncreasePriceInterval,
  RecurringFeeInterval,
} from "../enums";
import { PricePageRecurringInputModel } from "../models";

interface Iprops {
  padding?: string;
  height?: string;
  bgColor?: string;
  color?: string;
  border?: string;
  borderRadius?: string;
  minHeight?: string;
  width?: string;
  maxWidth?: string;
  placementSlider?: number;
}

export const PricingTableWrapper = styled.div`
  width: 100%;
  .styled-table-wrapper {
    overflow-x: auto;
    min-width: 500px;
    &::-webkit-scrollbar {
      width: 0.4em;
      height: 0.6em;
      background: transparent;
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb {
      outline: 1px solid #ddd;
      background-color: rgba(21, 40, 55, 0.3);
      border-radius: 10px;
    }
  }

  .show-column-chkbox {
    label {
      font-size: 14px;
      font-weight: 400;
    }
    input {
      height: 17px !important;
      width: 17px !important;
      margin-top: 1px !important;
    }
  }
  .add-package-btn {
    background: no-repeat;
    color: #586db9;
    border: none;
    font-size: 14px;
    padding: 0px 53px 0px 0px;
    line-height: 16px;
    min-width: 90px;
    margin-left: 40px;

    > img {
      margin-right: 7px;
      vertical-align: initial;
      height: 15px;
      width: 15px;
    }
    > span {
      margin-top: 2px;
    }
    &:active,
    &:focus,
    &:hover {
      outline: none;
      background-color: #fff;
      border: none;
      color: #586db9;
    }
  }
  .tier-table {
    table {
      th:first-child {
        text-align: left;
        padding-left: 25px;
      }
      tr td:first-child {
        text-align: left;
        padding-left: 25px;
      }
    }
  }
`;

export const DonationPayButton = styled(CustomButton)<Iprops>`
  margin-top: 40px;
  min-height: 40px;
  height: ${(props) => (props.height ? props.height : "auto")} !important;
  line-height: 22px;
  width: 100%;
  font-size: 18px;
  text-align: center;
  background-color: ${(props) =>
    props.bgColor ? props.bgColor : "#2c3e50"} !important;
  font-weight: 600 !important;
  color: ${(props) => props.color || "#fff"} !important;
  &.purchase-donation-btn {
    min-height: 50px !important;
    height: auto !important;
    color: ${(props) => props.color || "#fff"} !important;
  }
`;

export const MembershipRightBar = styled.div<Iprops>`
  width: ${(props) => props.width || "480px"};
  height: ${(props) => props.height || "100%"};
  background: ${(props) => props.bgColor || "#eee"};
  padding: ${(props) => props.padding || "40px 30px"};
  border-radius: ${(props) => props.borderRadius || "0px"};
  &.float-block {
    position: fixed;
    /* top: 55px;
    right: 20px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    position: fixed; */
    top: 60px;
    right: 20px;
    box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    height: calc(100% - 72px);
    border-radius: 8px;
    display: flex;
    justify-content: center;
  }

  .textarea-wrapper {
    width: 100%;
    margin: 15px 0px 0px;

    textarea.styled-input {
      width: 100%;
      text-align: center;
      &::placeholder {
        font-size: 14px;
      }
    }
  }
  .chkbox-wrapper {
    width: 100%;
  }

  .chkbx-list-wrapper {
    width: 100%;
    color: #555;
    margin-top: 25px;
    padding-left: 32px;
    padding-right: 40px;

    textarea.styled-input {
      border: 1px solid #2c3e50;
      text-align: left;
      &::placeholder {
        color: #555;
        font-size: 16px;
      }
    }
    .input-wrapper {
      width: 100%;
      input[type="text"].styled-input {
        width: 100%;
        border: 1px solid #2c3e50;
        &::placeholder {
          color: #555;
          font-size: 16px;
        }
      }
    }
  }
  .styled-chkbox {
    margin-top: 30px;
    display: flex;
    .form-check-input:checked {
      border-color: #2c3e50;
      background-color: #2c3e50;
    }
    ruby-span,
    label {
      word-break: break-word;
    }
  }
  .adv-benefit-btn {
    max-width: 140px;
  }
  .donation-btn {
    margin-top: 40px;
    min-height: 40px;
    height: auto;
    line-height: 22px;
    width: 100%;
    font-size: 18px;
    text-align: center;
    background-color: #2c3e50 !important;
    font-weight: 400 !important;
    color: #fff;
  }
  &.default-layout {
    position: absolute;
  }

  &.donation-layouts {
    /* width: 50%; // creating issue for donation with background image, any way we have max width of 480px */
  }
  @media (max-width: 576px) {
    &.donation-layouts {
      width: 100%;
    }
    &.default-layout {
      position: unset;
    }
  }
  @media (max-width: 1600px) {
    &.float-for-ss {
      max-width: 475px;
      &.float-block {
        right: 7px;
      }
      > div {
        padding: 40px 20px;
      }
    }
  }
`;

export const CustomDonationButton = styled(CustomButton)<Iprops>`
  background-color: ${(props) =>
    props.bgColor ? props.bgColor : "#e7e9ec"} !important;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  border-radius: 4px;
  color: ${(props) => (props.color ? props.color : "#2c3e50")} !important;
  border: none;
  min-height: 50px;
  height: auto;
  min-width: 175px;
  max-width: unset;
  width: 100%;
  padding: 8px;
  &.selected {
    background-color: ${(props) =>
      props.bgColor ? props.bgColor : "#2c3e50"} !important;
    color: ${(props) => (props.color ? props.color : "#fff")} !important;
    border: none;
  }
  &.adv-increase-btn {
    height: 35px;
    min-height: 35px;
    min-width: 50px;
    padding: 4px;
    color: ${(props) => (props.color ? props.color : "#2c3e50")};
  }
  @media (max-width: 468px) {
    min-width: 150px !important;
  }
`;
export const AdvertisingBlockWrapper = styled.div<Iprops>`
  display: flex;
  min-width: 460px;
  width: ${(props) => props.width || "402px"};
  min-height: ${(props) => props.minHeight || "200px"};
  height: 100%;
  padding: ${(props) => props.padding || "40px 30px"};
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  border-radius: 10px;
  overflow-y: auto;
  border: ${(props) => props.border || "1px solid #fbfbfb"};
  background: ${(props) => props.bgColor || "#fbfbfb"};
  max-width: ${(props) => props.maxWidth || "402px"};
  &::-webkit-scrollbar {
    width: 0.2em;
    height: 0.6em;
    background: transparent;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    outline: 1px solid #ddd;
    background-color: rgba(21, 40, 55, 0.3);
    border-radius: 10px;
  }

  .advert-img {
    width: 100%;
    height: 159px;
    flex-shrink: 0;
    border-radius: 10px;
  }
  ${PriceSelector} {
    width: 108px; //increasing this will reflect advertising block
    .price-selector-input {
      max-width: 65px;
    }
  }
  .pointing-upwards-icon {
    position: relative;
    padding: 10px 0px 0px;
    label {
      letter-spacing: 0.2px;
    }
    img {
      height: 29px;
      width: 40px;
      margin-bottom: 15px;
      position: absolute;
      left: 0;
      top: 0;
      transform: translate(-29px, -6px) rotate(13deg);
    }
  }
  .adv-pricing-option {
    width: 110px;
    border: none;
    cursor: pointer;
    /* font-size: 16px !important; */
    &.custom-dollar-icon {
      &::before {
        content: "";
      }
      .input-wrapper {
        position: relative;
        &::before {
          content: "$";
          position: absolute;
          top: 50%;
          left: 5px;
          transform: translateY(-50%);
          font-size: 18px;
          color: #555;
        }
      }
      .price-selector-input {
        max-width: 80px;
        padding-left: 18px;
      }
    }
  }
  ${CustomButton} {
    background-color: #e7e9ec;
    font-weight: 600;
    font-size: 16px;
    border-radius: 4px;
    color: #2c3e50;
    border: none;
    min-height: 50px;
    height: auto;
    min-width: 175px;
    &.selected {
      background-color: #2c3e50;
      color: #fff;
      border: none;
    }
    &.adv-increase-btn {
      height: 35px;
      min-height: 35px;
      min-width: 50px;
      padding: 4px;
      width: auto;
    }
  }
  .usd-label {
    color: #aaa;
    font-size: 18px;
  }
  ${CustomLabel}.actual-price {
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    color: #000;
    margin: "10px 0px";
  }
  .carousel-dummy-image {
    width: 100%;
    height: 100%;
    max-width: 254px;
    border-radius: 4px;
    object-fit: contain;
    display: none;
  }
  &.donation-ad-block {
    height: auto;
    overflow-y: auto;
    max-height: calc(100vh - 150px);
    margin: 0 auto;
    padding: 20px 25px; //make changes here
    &::-webkit-scrollbar {
      width: 0.4em;
      height: 0.6em;
      background: transparent;
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb {
      outline: 1px solid #ddd;
      background-color: rgba(21, 40, 55, 0.3);
      border-radius: 10px;
    }
    .carousel-indicators {
      transform: translate(-48%, 100%);
    }
    .active.carousel-item {
      text-align: center;
    }
  }
  &.bg-image-ad-block {
    position: absolute;
    height: calc(100vh - 150px);
    top: 50%;
    left: ${(props) =>
      props.placementSlider ? props.placementSlider + "%" : "0%"};
    transform: translate(-50%, -50%);
    transition: all 0.3s ease-in-out;
  }
  .adv-full-view {
    max-width: 402px;
  }

  @media (max-width: 468px) {
    /* width: 80% !important; */
    min-width: 250px;
    &.donation-ad-block {
      width: 100%;
      /* overflow-y: unset; */
    }
    .donation-choose-amount {
      max-width: 100%; // might be not required
    }
  }
  @media (max-width: 768px) {
    .carousel-dummy-image {
      width: 100%;
      height: 100%;
      max-width: 254px;
      border-radius: 4px;
      object-fit: contain;
    }
    &.donation-ad-block .full-width {
      .chkbox-wrapper .styled-chkbox {
        margin-top: 15px !important;
      }
    }
  }
  @media (max-width: 1024px) {
    &.bg-image-ad-block {
      position: unset;
      transform: unset;
    }
    /* &.donation-ad-block {
      &.no-padding-small-devices {
        padding: 0px;
        .donation-image-wrapper {
          width: 100%;
        }
      }
    } */
    .donation-title-padding { // created issue for the donation block for screen less than 1024px
      padding: 0px 25px 30px;
    }
  }
  /* @media (max-width: 576px) { */ // background image is not visible in tablet view
  @media (max-width: 1024px) {
    &.donation-ad-block {
      &.no-padding-small-devices {
        padding: 0px;
        .donation-image-wrapper {
          width: 100%;
        }
      }
    }
  }
`;

export const OptionSelectorCard = styled.div`
  width: 268px;
  min-height: 220px;
  height: auto;
  border-radius: 15px;
  border: 1px solid #556bb8;
  background: #fff;
  padding: 20px 35px;
  display: flex;
  align-items: center;
  flex-direction: column;
  &.ad-selector-card {
    width: 285px;
    justify-content: center;
    box-shadow: 0px 4px 7px -1px rgba(0, 0, 0, 0.25);
  }
  .product-pricing-row {
    margin: 6px auto 30px;
    input {
      width: 100%;
      height: 40px;
      border: 1px solid #556bb8;
      border-radius: 8px;
    }
  }
`;

export const MembershipTierDetails = styled.div`
  .row {
    margin-bottom: 20px;
    padding: 20px;
    margin-left: 0;
    margin-right: 0;

    &.selected {
      background-color: #f7f8fb;
      border-radius: 8px;
    }
  }
  img {
    height: 24px;
    width: 24px;
  }
  .editor-wrapper {
    img {
      height: auto;
      width: auto;
    }
  }

  span {
    /* color: #aaa; */ // creating issue for the text editor
    /* margin-right: 25px; */
  }
  .lock-icon {
    height: 18px;
    width: 14px;
    vertical-align: text-top;
    margin-left: 10px;
    margin-top: 2px;
  }
  .check-icon {
    height: 17px;
    width: 17px;
    margin-left: 10px;
    vertical-align: text-top;
    margin-top: 3px;
  }
  .icons-column {
    img:not(:last-child) {
      margin-right: 10px;
    }
    img {
      height: 16px;
      width: 16px;
      cursor: pointer;
    }
  }
  .usd-label {
    margin-left: 5px;
    font-size: 16px;
    margin-right: 5px;
    font-weight: 400;
  }
  .donation-amount {
    min-width: 300px;
    max-width: 700px;
    width: auto;
    .header {
      min-width: 300px;
      max-width: 700px;
      width: auto;
    }
    .select-header-span {
      color: #555;
    }
    .options-menu {
      width: 335px;
    }
  }
  .donation-textarea-plh {
    textarea::placeholder {
      color: #aaa;
    }
  }
  &.membership-tier {
  }
`;
export const SetupDetails = styled.div`
  .setup {
    margin-bottom: 45px;
    img {
      vertical-align: sub;
      width: 25px;
      height: 25px;
      margin-right: 10px;
    }
    i {
      vertical-align: middle;
      margin-left: 10px;
    }
  }
  .row {
    margin-bottom: 30px;
    padding: 0px;
  }

  .price-field {
    input[type="text"]:not(.number-selector, .searchable-dropdown-input) {
      width: 220px;
    }
    .number-selector {
      width: 100%;
    }
    span {
      display: flex;
      vertical-align: middle;
      /* color: #aaa; */ // sunil asked to change the color
      color: #555;
      align-items: center;
      /* line-height: 40px; */

      img {
        margin-right: 10px;
      }
    }
    .styled-input {
      width: 220px;
    }
  }
  .number-selector-wrapper {
    > div {
      margin-right: 0px;
    }
  }
  .price-description-field {
    input {
      width: 450px;
    }
  }
  .single-select-wrapper,
  .single-select-wrapper .header {
    width: 220px;
  }
  .fa-chevron-down,
  .fa-chevron-right {
    font-size: 15px;
    &:before {
      font-size: 15px;
    }
  }
  .styled-input.number-selector {
    width: 80px;
  }
  .billing-starts-row .select-header-span {
    color: #555;
  }
  .advanced-addition-section .select-header-span {
    color: #555;
  }
`;
export const RecurringWrapper = styled.div`
  .styled-table {
    margin-top: 0px !important;
    margin-bottom: 40px;
    thead tr:first-child th {
      padding-top: 0px !important;
    }
    .add-package-btn {
      span {
        color: #586db9;
      }
    }
  }
  .tier-table .styled-table {
    margin-bottom: 25px !important;
  }
`;

export const getOptions = (
  fieldName: keyof PricePageRecurringInputModel
): any[] => {
  switch (fieldName) {
    case "increasePriceInterval":
      return Object.keys(ItemIncreasePriceInterval).map((key: string) => {
        return {
          value: key,
          label:
            ItemIncreasePriceInterval[
              key as keyof typeof ItemIncreasePriceInterval
            ],
        };
      });
    case "increasePriceBy":
      return Object.keys(ItemIncreasePriceBy).map((key: string) => {
        return {
          value: key,
          label: ItemIncreasePriceBy[key as keyof typeof ItemIncreasePriceBy],
        };
      });
    case "feeInterval":
      return Object.keys(RecurringFeeInterval).map((key: string) => {
        return {
          value: key,
          label: RecurringFeeInterval[key as keyof typeof RecurringFeeInterval],
        };
      });
  }
  return [];
};
